import { useEffect, useState } from "react";
import LoginBackgroundImage from "../../../assets/images/LoginBackgroungImage.svg";
import LoaderPopupModel from "../common/LoaderPopup";
import {
  readFromLocalStorage,
  writeToLocalStorage,
} from "../../utils/DataEncryption";
import { jwtDecode } from "jwt-decode";
import { Constants } from "../../constants";
import { useLocation, useNavigate } from "react-router";
import { urlParameterConstants } from "../../constants/constants";
export interface DecodedToken {
  userType: string;
  name: string;
  dealerId: string;
  userId: string;
  baseRoles: any[];
  exp: number;
  aud: string;
  azp: string;
}

const SsoLogin = ({ selectedLoginMethod }: any) => {
  const location = useLocation();
  const selectedMethod = location.state?.selectedMethod ?? 0;
  const callBackUrlFromParms  = location.state?.callBackUrl;
  const  appIdFromParms  = location.state?.appId ;
  const scpFromParms  = location.state?.scp;
  const urlString = window.location.href; // Or any URL string
  const url = new URL(urlString);
  const params = new URLSearchParams(url.search);
  const selectedMethodFromparams = params.get("aut");
  // if (selectedMethodFromparams) {
  //   selectedMethod = selectedMethodFromparams === "UID" ? 1 : 0;
  // }
  const [alert, setAlert] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const handleLogin = () => {

    let url: any;
    const aut = selectedMethod == 1 ? "&aut=UID" : "";
    if (
          selectedMethod === 0 ||
          selectedMethod === 1 
        ) {
      const loginURL = `${process.env.REACT_APP_LOGINURL}/auth/v1/app/token`;
      const callbackUrl =
        callBackUrlFromParms || process.env.REACT_APP_LOGIN_REDIRECT_URL;
      const appId =
        appIdFromParms ||
        readFromLocalStorage("appId") ||
        process.env.REACT_APP_APPID;

      let scp;
      if (appIdFromParms && callBackUrlFromParms) {
        if (
          scpFromParms === null ||
          scpFromParms === undefined ||
          scpFromParms === ""
        ) {
          scp = `openId`;
        } else {
          scp = `openId%20${encodeURIComponent(scpFromParms)}`;
        }
      } else {
        scp = process.env.REACT_APP_SCP_URL;
      }
      url = `${loginURL}?app_id=${appId}&callback_uri=${callbackUrl}&country=IN&scp=${scp}${aut}`;
      console.log("url==>>",url)
      window.location.href = url;
    }
  };
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const token = urlParams.get("token") || readFromLocalStorage("token");
   if (token) {
    console.log("token", token);
      const urlWithoutToken = window.location.origin;
      const decodedToken: DecodedToken = jwtDecode(token);
      if (decodedToken?.exp) {
        const expiryTime = decodedToken.exp * 1000;
        if (expiryTime > Date.now()) {
          writeToLocalStorage("token", token);
          writeToLocalStorage("userName", decodedToken.name);
          writeToLocalStorage("userType", decodedToken.userType);
          writeToLocalStorage("dealerId", decodedToken.dealerId);
          writeToLocalStorage("userId", decodedToken.userId);
          writeToLocalStorage("appId", decodedToken.azp || decodedToken.aud);
          const decodedBaseRoles = decodedToken.baseRoles;
          const baseRolesArray = decodedBaseRoles.map((roleStr) =>
            JSON.parse(roleStr)
          );
          writeToLocalStorage("baseRoles", JSON.stringify(baseRolesArray));
          window.location.href = urlWithoutToken + "#/dashboard";
        } else {
          handleAlert(Constants.sessionConstants.SESSION_EXPIRED);
          handleLogin();
        }
      } else {
        handleLogin();
      }
    } else {
      handleLogin();
    }
  }, [params, url, appIdFromParms]);
  const handleAlert = (alertMsg: string) => {
    setAlertMsg(alertMsg);
    setAlert(true);
  };

  return (
    <div>
      <LoaderPopupModel isOpen={true} />
    </div>
  );
};

export default SsoLogin;
